'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _applications = require('./applications.service');

var _applications2 = _interopRequireDefault(_applications);

var _settings = require('./settings.service');

var _settings2 = _interopRequireDefault(_settings);

var _cars = require('./cars.service');

var _cars2 = _interopRequireDefault(_cars);

var _users = require('./users.service');

var _users2 = _interopRequireDefault(_users);

var _modal = require('../modal/modal.controller');

var _modal2 = _interopRequireDefault(_modal);

var _modal3 = require('../modal/modal.service');

var _modal4 = _interopRequireDefault(_modal3);

var _fake = require('./fake.service');

var _fake2 = _interopRequireDefault(_fake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var servicesModule = _angular2.default.module('parkingformApp.services', []);

servicesModule.service('Applications', _applications2.default);

servicesModule.service('Settings', _settings2.default);

servicesModule.service('Cars', _cars2.default);

servicesModule.service('Users', _users2.default);

servicesModule.controller('ModalController', _modal2.default);

servicesModule.service('Modal', _modal4.default);

servicesModule.service('Fake', _fake2.default);

exports.default = servicesModule;


// WEBPACK FOOTER //
// ./client/components/services/index.js